import BaseService from './base.service';

class TeamService extends BaseService {
  get basePath() {
    return 'teams';
  }
}

export default new TeamService();
